import { useMemo } from 'react';
import { isDemoEnv } from '@/config/utils';
import { ChatContextType } from '@/enums';
import { useAppSelector } from '@/store';

export const useChatSettings = () => {
  const groupFeatures = useAppSelector(state => state.group.features);

  const availableContextTypes = useMemo(() => {
    const values: ChatContextType[] = [];

    if (groupFeatures.hcpProfiles) {
      values.push(ChatContextType.KolProfile);
    }

    if (groupFeatures.workspaces || isDemoEnv()) {
      values.push(ChatContextType.Global);
    }

    if (groupFeatures.workspaces) {
      values.push(ChatContextType.Document);
      values.push(ChatContextType.Folder);
    }

    return values;
  }, [groupFeatures]);

  const defaultContextType = useMemo(() => {
    if (groupFeatures.hcpProfiles) {
      return ChatContextType.KolProfile;
    }

    return ChatContextType.Global;
  }, [groupFeatures]);

  return useMemo(() => ({
    availableContextTypes,
    defaultContextType,

    hcpProfiles: groupFeatures.hcpProfiles,
    workspaces: groupFeatures.workspaces,
  }), [availableContextTypes, defaultContextType, groupFeatures.hcpProfiles, groupFeatures.workspaces]);
};